import React, { useEffect } from 'react';

import { Grid } from '@material-ui/core';

function Curriculum({ styles, data }) {
  useEffect(() => {}, [data]);
  return (
    <div>
      {data.curriculumDetails ? (
        <Grid item xs={12}>
          <div className={styles.sectionContainer}>
            <div className={styles.section}>
              <div className={styles.subSection}>
                <p className={styles.sectionText}>Curriculum Details</p>
                <div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Board</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.curriculumDetails.board}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.dashedBorderBottomNoPadd}></div>
                  <Grid container>
                    <Grid item xs={5}>
                      <p className={styles.sectionSubText}>Affiliation No.</p>
                    </Grid>
                    <Grid item xs={7}>
                      <p className={styles.sectionSubTextNoWeight}>
                        {data.curriculumDetails.affiliationNumber}
                      </p>
                    </Grid>
                  </Grid>
                  <div className={styles.dashedBorderBottomNoPadd}></div>
                </div>
                <p className={styles.sectionSubTextNoWeight}>
                  {data.curriculumDetails.curriculumDescription}
                </p>
              </div>
            </div>
          </div>
        </Grid>
      ) : null}
    </div>
  );
}

export default Curriculum;
